import { Component } from '../../../engine/ecs/core/Component';

/**
 * Types of collectible items in Pacman
 */
export enum CollectibleType {
  Dot = 'dot',
  PowerPellet = 'power_pellet',
  Cherry = 'cherry',
  Strawberry = 'strawberry',
  Orange = 'orange',
  Apple = 'apple',
  Melon = 'melon',
  Galaxian = 'galaxian',
  Bell = 'bell',
  Key = 'key',
}

/**
 * CollectibleComponent - Data for items that can be collected
 * Pure data component following ECS principles
 */
export class CollectibleComponent extends Component {
  public collectibleType: CollectibleType;
  public points: number;
  public isConsumed: boolean;
  public isPowerPellet: boolean;
  public powerDuration: number;
  public blinkTimer: number;
  public blinkSpeed: number;
  public isVisible: boolean;

  // Bonus fruit specific
  public spawnTimer: number;
  public lifeTime: number;
  public bonusMultiplier: number;

  constructor(collectibleType: CollectibleType, points: number = 10) {
    super();
    this.collectibleType = collectibleType;
    this.points = points;
    this.isConsumed = false;
    this.isPowerPellet = collectibleType === CollectibleType.PowerPellet;
    this.powerDuration = this.isPowerPellet ? 10.0 : 0;
    this.blinkTimer = 0;
    this.blinkSpeed = 0.3;
    this.isVisible = true;

    // Bonus fruit properties
    this.spawnTimer = 0;
    this.lifeTime = this.isBonusFruit() ? 10.0 : 0;
    this.bonusMultiplier = this.calculateBonusMultiplier();
  }

  /**
   * Check if this collectible is a bonus fruit
   */
  private isBonusFruit(): boolean {
    return (
      this.collectibleType !== CollectibleType.Dot &&
      this.collectibleType !== CollectibleType.PowerPellet
    );
  }

  /**
   * Calculate bonus multiplier based on item type
   */
  private calculateBonusMultiplier(): number {
    switch (this.collectibleType) {
      case CollectibleType.Cherry:
        return 1;
      case CollectibleType.Strawberry:
        return 2;
      case CollectibleType.Orange:
        return 3;
      case CollectibleType.Apple:
        return 4;
      case CollectibleType.Melon:
        return 5;
      case CollectibleType.Galaxian:
        return 6;
      case CollectibleType.Bell:
        return 7;
      case CollectibleType.Key:
        return 8;
      default:
        return 1;
    }
  }

  public clone(): CollectibleComponent {
    const clone = new CollectibleComponent(this.collectibleType, this.points);
    clone.isConsumed = this.isConsumed;
    clone.isPowerPellet = this.isPowerPellet;
    clone.powerDuration = this.powerDuration;
    clone.blinkTimer = this.blinkTimer;
    clone.blinkSpeed = this.blinkSpeed;
    clone.isVisible = this.isVisible;
    clone.spawnTimer = this.spawnTimer;
    clone.lifeTime = this.lifeTime;
    clone.bonusMultiplier = this.bonusMultiplier;
    return clone;
  }
}
